import { Navigate, Route, Routes } from "react-router-dom";
import { NowProvider } from "./hooks/useNow";
import StatusPage from "./pages/StatusPage";
import CameraPage from "./pages/CameraPage";
import AdminPage from "./pages/AdminPage";

/**
 * App shell — page-based routing.
 *
 * URL 이 곧 화면이다(탭 state 아님) → 새로고침/딥링크 시 보던 화면이 유지된다.
 *   "/"        실시간 대시보드
 *   "/history" 이력
 *   "/camera"  카메라 화각(FOV) 변화 감지
 *   "/admin"   관리자 (임계값·알림 설정) — 로그인 필요
 * SPA history fallback(nginx try_files → index.html) 덕에 deep-link 도 동작한다.
 * "/" 와 "/history" 는 StatusPage, "/camera" 는 CameraPage 가 렌더한다.
 *
 * `/admin` 은 공용 탭(PageTabs)에 넣지 않는다 — 조회용 페이지를 보러 온 사람에게
 * 노출할 이유가 없고, 접근 제어는 어차피 서버가 한다.
 */
export default function App() {
  return (
    <NowProvider>
      <Routes>
        <Route path="/" element={<StatusPage />} />
        <Route path="/history" element={<StatusPage />} />
        <Route path="/camera" element={<CameraPage />} />
        <Route path="/admin" element={<AdminPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </NowProvider>
  );
}
